export const SHOW_BODY_SELECTOR = {
  NONE: 'none',
  SELECTION: 'selection',
  POPUP: 'popup'
};
